import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
var SIGNUP_SOURCE;

(function (SIGNUP_SOURCE) {
  SIGNUP_SOURCE["CREATE_ACCOUNT"] = "createacct";
  SIGNUP_SOURCE["CHECKOUT"] = "togo_trans";
})(SIGNUP_SOURCE || (SIGNUP_SOURCE = {}));

var Config = /*#__PURE__*/function () {
  function Config() {
    _classCallCheck(this, Config);

    _defineProperty(this, "postfix", {
      UPDATE_ITEM: "/web-api/order/update",
      ADD_ITEM: "/web-api/order/add",
      DELETE_ITEM: "/web-api/order/delete",
      INITIATE_CHECKOUT: "/api/order/initiateCheckout",
      LOCATION_TIME: "/api/order/pickup/locationTime",
      SUBMIT_ORDER: "/api/order/submit",
      RESTAURANT_DETAILS: "/api/restaurants/{restaurantNumber}?locale=en_US",
      ADD_RESTAURANT_TO_FAVORITES: "/api/favorite/location?locale=en_US",
      REMOVE_RESTAURANT_FROM_FAVORITES: "/api/favorite/location/{restaurantNumber}",
      PROFILE_FAVORITE_LOCATIONS: "/api/profile/favorite/locations",
      SEARCH_RESTAURANT: "/api/restaurants",
      INIT_DETAILS: "/api/config/initDetails",
      CART_ORDER_DETAILS: "/api/order/details",
      CORS_URL: "/mAccountsWeb/AccountService/v1/tokens",
      CORS_URL_RSA: "/ucom/v1/account-tokens",
      RESOURCE_BUNDLE: "/api/config/i18n/resources",
      APP_INIT: "/api/config/appinit",
      CHECKOUT_INIT: "/api/order/checkout/init",
      GC_SESSION_INIT: "/web-api/giftcardcheckout/sessioninit",
      GC_SUBMIT_ORDER: "/web-api/giftcardorder/submit",
      SESSION_TOKEN: "/web-api/paymentservice/sessiontoken",
      MOBILE_PAY_SESSION_TOKEN: "/web-api/paymentservice/mobilepay/sessiontoken",
      GC_SESSION_TOKEN: "/web-api/paymentservice/giftcard/sessiontoken",
      RSA_TOKEN: "/api/payment/rsaToken",
      VALIDATE_TOKEN: "/api/payment/validateToken",
      GET_APPLE_PAY_TOKEN: "/api/payment/getApplePayToken",
      APPLY_COUPON: "/api/order/applyCoupon",
      REMOVE_COUPON: "/api/order/removeCoupon",
      CHECK_GC_BALANCE: "/api/profile/giftCard/balance",
      LOGIN: "/web-api/profile/login",
      LOGOUT: "/web-api/profile/logout",
      SOCIAL_LINK: "/web-api/profile/sociallink",
      PROFILE: "/api/profile/details",
      EDIT_PROFILE_NAME: "/api/profile/name",
      EDIT_PROFILE_EMAIL: "/api/profile/email",
      EDIT_PROFILE_PASSWORD: "/api/profile/password",
      EDIT_PROFILE_PHONE: "/api/profile/phone/{phoneId}",
      EDIT_PROFILE_FAV_LOCATION: "/api/favorite/location",
      EDIT_PROFILE_DOB: "/api/profile/dateofbirth",
      TOKENIZE_PAYPAL: "/web-api/paymentservice/getPaypalAuthToken",
      PICKUP_TIMES: "/api/order/pickup/times",
      SETPICKUP_TIME: "/api/order/pickupTime",
      CHECK_CARSIDE_AVAIL: "/api/order/carsidePickup/available?locale={locale}&orderId={orderId}",
      CAPACITY_TIMES_SLOTS: "/web-api/order/pickup/capacitytimeslots",
      ZIPCODE_QUERY: "/commerce/payment/service/DardenPaymentServlet/getCityState",
      GET_CITY_STATE_BY_ZIPCODE: "/api/payment/getCityState",
      SAVE_GIFT_CARD: "/api/profile/giftCard/add",
      TOKENIZATION_FAILURE: "/api/payment/creditCard/tokenizationFailure",
      MOBILE_PAY_CHECK_API: "/api/mobilePay/orders",
      MOBILE_PAY_APPLY_COUPON_API: "/api/mobilePay/applyCoupon",
      MOBILE_PAY_REMOVE_COUPON_API: "/api/mobilePay/removeCoupon",
      MOBILE_PAY_PAYMENT_API: "/api/mobilePay/payment",
      MOBILE_PAY_SEND_EMAIL_CONFIRMATION: "/api/mobilePay/receipts",
      MOBILE_PAY_APP_INIT: "/api/mobilePay/appInit",
      CATEGORY_MENU_ITEMS: "/api/menu",
      MENU_ITEM_DETAILS: "/api/menu/{productId}?restaurantNum={restaurantNum}",
      MENU_ITEMS_86ED: "/web-api/restaurant/86edProducts?restaurantId={restaurantId}",
      ITEM_86ED: "/api/86editems?&query=en_US",
      MENU_DAY_PART_API: "/web-api/restaurant/getProductsDayPartInfo?restaurantId={restaurantId}",
      ORDER_HISTORY_API: "/api/profile/orders",
      USER_PROFILE_ORDERS: "/api/profile/orders/history",
      RECENT_ORDERS_API: "/web-api/to-come",
      LIST_FAVORITES_API: "/web-api/profile/favorite/products",
      SAVE_FAVORITES: "/web-api/favorite/add-favorite",
      REMOVE_FAVORITES: "/web-api/favorite/remove-favorite",
      CURBSIDE_CHECK_SUMMARY_API: "/api/curbside/checksummary",
      CURBSIDE_CHECK_SUMMARY_APIv2: "/api/curbside/v2/checksummary",
      CURBSIDE_CHECK_IN_API: "/api/curbside/checkin",
      CURBSIDE_RESTAURANT_NUMBER_API: "/web-api/restaurant/{restaurantNumber}?restNumFlag={restNumFlag}",
      UPDATE_LOCATION: "/api/order/location",
      I18N_RESOURCES: "/web-api/i18n/resources",
      RECOMMENDATION_LIST_API: "/api/recommendations?locale=en_US",
      FREQUENTLY_ORDERED_ITEM: "/api/order/profile/frequentlyOrdered",
      CLEAR_CART: "/api/order/cart/clear",
      RESTAURANT_PDF_CONF: "/web-api/menu/pdf",
      SET_DELIVERY_PARTY_SIZE: "/api/order/partySize",
      GET_DELIVERY_RESTAURANTS: "/api/restaurants/delivery",
      GET_EXTERNAL_DELIVERY_RESTAURANTS: "/api/restaurants/external-delivery",
      SET_CATERING_DELIVERY_DETAILS: "/web-api/order/setDeliveryDetails",
      SEARCH_AUTOCOMPLETE: "https://maps.googleapis.com/maps/api/place/autocomplete/json",
      SEARCH_BY_ADDRESS: "https://maps.googleapis.com/maps/api/geocode/json",
      FACEBOOK_USER_INFO_API: "https://graph.facebook.com/me?fields=id,name,email,picture",
      GOOGLE_USER_INFO_API: "https://www.googleapis.com/oauth2/v1/userinfo?alt=json",
      MAPBOX_DISTANCE: "https://api.mapbox.com/directions-matrix/v1/mapbox/driving/{coordinates}?annotations=distance&sources=0",
      MAPBOX_DISTANCE_AND_DURATION: "https://api.mapbox.com/directions-matrix/v1/mapbox/driving/{coordinates}?destinations=all&annotations=duration,distance&sources=0",
      MAPBOX_SEARCH_AUTOCOMPLETE: "https://api.mapbox.com/geocoding/v5/mapbox.places/{address}.json?language=en-GB",
      SET_DELIVERY_ADDRESS: "/api/order/deliveryAddress",
      SET_DELIVERY_TIME: "/api/order/deliveryTime",
      LAST_ORDER_DETAILS: "/web-api/order/lastOrderDetails",
      JOIN_ECLUB: "/api/eclub",
      GET_BEER_MENU_WIDGET: "/web-api/getbeermenuwidget",
      SIGNUP: "/web-api/profile?locale={locale}",
      UPDATE_PROFILE: "/web-api/profile/{userId}",
      RATE_YOUR_VISIT: "/web-api/order/feedback",
      UPDATE_PROFILE_INFO: "/web-api/profile",
      RESET_PASSWORD_REQUEST: "/web-api/profile/passwordresetrequest",
      RESET_PASSWORD: "/web-api/profile/passwordreset",
      DELETE_GIFT_CARD: "/api/profile/giftCard/delete",
      INIT_DINE_IN_ORDER: "/api/order/initiateDineInOrder?orderId={orderId}&restaurantNum={restaurantNum}&visitId={visitId}&source={source}&kind={kind}",
      WAITLIST: "/api/waitlist",
      GET_WAIT_TIME: "/api/waitlist/waittime",
      GET_WAITLIST: "/api/waitlist/{waitListId}",
      GET_SETTING_DATA_API: "https://services.darden.com/api/v1",
      LIST_LOCATIONS: "/api/restaurants/lookup",
      CHANGE_PASSWORD: "/web-api/profile/changePassword",
      ORDER_DETAILS: "/web-api/order/details?conceptCode={conceptCode}&locale={locale}",
      GET_VISIT_BY_VISIT_ID: "/api/waitlist/getVisitById",
      GET_VISIT_BY_VISIT_ID_YH: "/wl-home",
      GET_VISIT_BY_TOKEN: "/api/waitlist/getVisitByToken",
      CHECK_IN_VISIT: "/api/waitlist/checkin",
      CANCEL_VISIT: "/api/waitlist/cancel",
      RESERVATION_RESTAURANTS: "/api/restaurants/reservation",
      RESERVATION_RESTAURANT_TIMESLOTS: "/api/reservations/timeslots",
      RESERVATION_AVAILABLE_TIMESLOTS: "/api/reservations/available/timeslots",
      RESERVATIONS: "/api/reservations",
      GET_RESERVATIONS: "/api/reservations/lookup",
      RESERVATION_NOTIFICATION: "/api/reservations/notification",
      GET_TARGETERS: "/web-api/targeter/GetTargeter?targeterPath={targeterPath}&restNumber={restNumber}&conceptCode={conceptCode}&channel={channel}",
      APPLY_BAG_FEE: "/api/order/bagFee?locale={locale}",
      REMOVE_BAG_FEE: "/api/order/bagFee?locale={locale}orderId={orderId}",
      GUEST_AT_RESTAURANT_VICINITY: "/api/orders/guestvicinity",
      PRIVATE_DINING: "/api/dining/private-dining",
      GROUP_DINING: "/api/dining/group-dining",
      PAYMENT_METHODS: "/api/profile/paymentMethods",
      GET_GIFT_CARDS: "/api/profile/giftCards",
      GET_CREDIT_CARDS: "/api/profile/creditCards",
      ADD_CREDIT_CARD: "/api/profile/creditCard/add",
      DELETE_CREDIT_CARD: "/api/profile/creditCard/delete",
      PRIVATE_DINING_CONTENT: "/api/dining/private-dining/content?restaurantNum={restaurantNum}&locale=en_US",
      GET_WINE_LIST: "/winelist",
      GUEST_AUTHENTICATION: "/winelocker/authenticate",
      WINE_LOCKER_DETAILS: "/winelocker/locker",
      ADD_WINE_TO_LOCKER: "/winelocker/locker/wine/add",
      WINE_LOCKERS_BY_OWNER: "/winelocker/owner/lockers",
      WINE_LOCKERS_BY_LOCATION: "/winelocker/lockers",
      WINE_LOCKERS_CREATE_GIFT: "/winelocker/locker/gift/create",
      WINE_LOCKER_CHANGE_VISIBILITY: "/winelocker/locker/edit",
      ADD_KEYHOLDER: "/winelocker/locker/owner/invite",
      REMOVE_KEYHOLDER: "/winelocker/locker/owner/remove",
      WINE_LOCKER_HISTORY: "/winelocker/locker/history",
      ACCEPT_GIFT: "/winelocker/locker/gift/accept",
      SEARCH_RESTAURANTS_FOR_PRIVATE_DINING: "/api/restaurants/privatedining?locale=en_US",
      RESTAURANT_DETAILS_WITH_RDP_DATE: "/api/restaurants/{restaurantNumber}?locale=en_US&restaurantNumber={restaurantNumber}&rdpDate={rdpDate}",
      CART: "/api/order/cart",
      EXTERNAL_DELIVERY_CREATE_QUOTE: "/api/order/create-quote",
      EXTERNAL_DELIVERY_CREATE: "/api/order/external-delivery",
      UPDATE_DELIVERY_COOKIE: "/api/order/update-cookie"
    });

    _defineProperty(this, "publicLinks", {
      privacyPolicy: "/privacy-policy",
      terms: "https://contentservicesstg.darden.com/mobileapp/privacy-policy?format=json&channel=mobileapp&concept=OG&locale=en_US&pushSite=oliveGardenMobileSite",
      giftCards: "/gift-cards",
      JoinEClub: "/customer-service/join-eclub",
      cateringDelivery: "/delivery/catering-delivery-address",
      doNotSellDataRequest: "https://privacyportal.onetrust.com/webform/ba9aad07-e9b8-4a45-8cfa-96268092be69/d0443d50-5157-4a94-ab3c-7e7a97738a7a",
      faqs: "/faqs",
      legalNotices: "/legal-notices",
      deleteAccount: "https://privacyportal.onetrust.com/webform/ba9aad07-e9b8-4a45-8cfa-96268092be69/d19cf2ee-2646-46a9-a49f-239ec4760dac",
      privateDining: "/private-dining/home",
      recipe: "https://www.thecapitalgrille.com/mobileapp/events/recipes",
      contactUS: "https://www.thecapitalgrille.com/contact-us"
    });

    _defineProperty(this, "config", {
      environment: "development",
      local: {
        SERVICES_API_PREFIXES: {
          "/api": "https://atgservicesdev3.darden.com",
          "/web-api": "https://stage-3.olivegarden.com"
        },
        DEFAULT_SERVICES_API_PREFIX: "https://stage-3.olivegarden.com",
        CORS_DOMAIN: "https://cat-ngn.fdmobileservices.com",
        CORS_DOMAIN_RSA: "https://api-int.payeezy.com"
      },
      development: {
        SERVICES_API_PREFIXES: {
          "/api": "",
          "/web-api": ""
        },
        DEFAULT_SERVICES_API_PREFIX: "",
        CORS_DOMAIN: "https://cat-ngn.fdmobileservices.com",
        CORS_DOMAIN_RSA: "https://api-int.payeezy.com"
      },
      production: {
        SERVICES_API_PREFIXES: {
          "/api": "",
          "/web-api": ""
        },
        DEFAULT_SERVICES_API_PREFIX: "",
        CORS_DOMAIN: "https://www.fdmobileservices.com",
        CORS_DOMAIN_RSA: "https://api.payeezy.com"
      }
    });

    _defineProperty(this, "commonQueryParams", void 0);

    _defineProperty(this, "commonHeaders", void 0);

    _defineProperty(this, "commonProps", void 0);

    _defineProperty(this, "conceptCode", void 0);

    _defineProperty(this, "messageEncryptionUtil", void 0);

    _defineProperty(this, "messageEncryptionUtilOpts", void 0);
  }

  _createClass(Config, [{
    key: "getConceptCode",
    value: function getConceptCode() {
      return this.conceptCode;
    }
  }, {
    key: "setConceptCode",
    value: function setConceptCode(conceptCode) {
      this.conceptCode = conceptCode;
    }
  }, {
    key: "setEnvironment",
    value: function setEnvironment(env) {
      this.config.environment = env;
    }
  }, {
    key: "getEnvironment",
    value: function getEnvironment() {
      return this.config.environment;
    }
  }, {
    key: "setCommonProps",
    value: function setCommonProps(props) {
      this.commonProps = props;
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      return this.commonProps;
    }
  }, {
    key: "setMessageEncryptionUtil",
    value: function setMessageEncryptionUtil(messageEncryptionUtil) {
      this.messageEncryptionUtil = messageEncryptionUtil;
    }
  }, {
    key: "getMessageEncryptionUtil",
    value: function getMessageEncryptionUtil() {
      return this.messageEncryptionUtil;
    }
  }, {
    key: "setMessageEncryptionOpts",
    value: function setMessageEncryptionOpts(messageEncryptionOptions) {
      this.messageEncryptionUtilOpts = messageEncryptionOptions;
    }
  }, {
    key: "getMessageEncryptionOpts",
    value: function getMessageEncryptionOpts() {
      return this.messageEncryptionUtilOpts;
    }
  }, {
    key: "overrideEndpoint",
    value: function overrideEndpoint(apiPostFix, endpoint) {
      var existing = this.postfix[apiPostFix];

      if (existing) {
        delete this.postfix[apiPostFix];
      }

      this.postfix[apiPostFix] = endpoint;
    }
  }, {
    key: "setCommonQueryParams",
    value: function setCommonQueryParams(queryParams) {
      var env = queryParams.env;

      if (env) {
        var config = this.config[this.config.environment];
        config.ENV = env;
        delete queryParams.env;
      }

      this.commonQueryParams = queryParams;
    }
  }, {
    key: "getCommonQueryParams",
    value: function getCommonQueryParams() {
      return this.commonQueryParams;
    }
  }, {
    key: "setCommonHeaders",
    value: function setCommonHeaders(headers) {
      this.commonHeaders = headers;
    }
  }, {
    key: "getCommonHeaders",
    value: function getCommonHeaders() {
      return this.commonHeaders;
    }
  }, {
    key: "getPrefix",
    value: function getPrefix() {
      return this.config[this.config.environment];
    }
  }, {
    key: "setAPIPrefix",
    value: function setAPIPrefix(apiPrefix, context) {
      var config = this.config[this.config.environment];

      if (context) {
        config.SERVICES_API_PREFIXES[context] = apiPrefix;
      } else {
        if (config.SERVICES_API_PREFIXES) {
          Object.keys(config.SERVICES_API_PREFIXES).forEach(function (ctxt) {
            config.SERVICES_API_PREFIXES[ctxt] = apiPrefix;
          });
        }
      }
    }
  }, {
    key: "setDefaultAPIPrefix",
    value: function setDefaultAPIPrefix(apiPrefix) {
      var config = this.config[this.config.environment];
      config.DEFAULT_SERVICES_API_PREFIX = apiPrefix;
    }
  }, {
    key: "getDefaultAPIPrefix",
    value: function getDefaultAPIPrefix() {
      var config = this.config[this.config.environment];
      return config.DEFAULT_SERVICES_API_PREFIX;
    }
  }, {
    key: "getGiftCardType",
    value: function getGiftCardType() {
      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "US";

      if (this.conceptCode) {
        switch (this.conceptCode) {
          case "YH":
            return "YRDHSE";

          case "OG":
            return location === "US" ? "OLIUSA" : "OLICAN";

          case "CS":
            return "CHEDDARS";

          case "LH":
            return "LNHORN";

          case "BB":
            return "BAHAMA";

          case "S52":
            return "SEAS52";

          case "CG":
            return "CAPGRL";

          case "EV":
            return "EDDIEV";

          case "CB":
            return "CAPGRL";

          default:
            return "DDCORP";
        }
      } else {
        return "OLIUSA";
      }
    }
  }, {
    key: "getSiteIds",
    value: function getSiteIds() {
      switch (this.conceptCode) {
        case "YH":
          return {
            mobileSiteId: "YardHouseMobileSite",
            siteId: "YardHouseSite"
          };

        case "OG":
          return {
            mobileSiteId: "oliveGardenMobileSite",
            siteId: "oliveGardenSite"
          };

        case "CS":
          return {
            mobileSiteId: "CheddarsMobileSite",
            siteId: "CheddarsSite"
          };

        case "LH":
          return {
            mobileSiteId: "longHornMobileSite",
            siteId: "LongHornSite"
          };

        case "BB":
          return {
            mobileSiteId: "BahamaBreezeMobileSite",
            siteId: "BahamaBreezeSite"
          };

        case "S52":
          return {
            mobileSiteId: "Seasons52MobileSite",
            siteId: "Seasons52Site"
          };

        case "CG":
          return {
            mobileSiteId: "The Capital Grille Mobile Site",
            siteId: "CapitalGrilleSite"
          };

        case "EV":
          return {
            mobileSiteId: "5600003",
            siteId: "EddieVSite"
          };

        case "CB":
          return {
            mobileSiteId: "CapitalGrilleBurgerMobile",
            siteId: "CapitalGrilleBurger"
          };

        default:
          return {
            mobileSiteId: null,
            siteId: null
          };
      }
    }
  }, {
    key: "getDardenChannel",
    value: function getDardenChannel() {
      return {
        appChannel: "DARDENMOBILEAPP",
        webChannel: null
      };
    }
  }, {
    key: "getSignUpSource",
    value: function getSignUpSource() {
      var flow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "CREATE_ACCOUNT";
      var APP_SOURCE_PREFIX = this.conceptCode.toLowerCase();
      var SOURCE = SIGNUP_SOURCE[flow];

      if (APP_SOURCE_PREFIX) {
        return {
          appSource: "".concat(APP_SOURCE_PREFIX, "_mapp_").concat(SOURCE)
        };
      } else {
        return {
          appSource: null
        };
      }
    }
  }]);

  return Config;
}();

export { Config as default };